<template>
  <a-modal
    v-model="visible"
    :title="title || modalTitle"
    :destroy-on-close="true"
    :footer="null"
    wrap-class-name="fullscreen-modal"
    dialog-class="answer-modal"
    :width="width"
    :after-close="afterClose"
    :z-index="1010"
  >
    <div class="modal-content">
      <template v-if="type === 'single'">
        <div class="modal-content-top">
          <div :style="{ zoom: zoom }" class="answer-overall">
            <div
              :class="[
                'answer-score',
                textEvaluate.result.scoreRate >= 85
                  ? 'col-1DC060'
                  : textEvaluate.result.scoreRate >= 60
                    ? 'col-FFA516'
                    : 'col-FF3C30'
              ]"
            >
              <template v-if="$store.getters.isGradeSchool">
                <img :src="Grade2ImgSrc(Number(textEvaluate.result.overall))" alt="" class="score-img" />
              </template>
              <template v-else>
                <span class="score">{{ Number(textEvaluate.result.overall).toFixed(2) }}</span>
                <span class="text">分</span>
              </template>
            </div>
            <div class="answer-star">
              <template v-for="index in 5">
                <img
                  :key="index"
                  class="answer-star-img"
                  :src="
                    index <= fetchStarNum(textEvaluate.result.scoreRate)
                      ? require('@/assets/common/star_highlight.png')
                      : require('@/assets/common/star_grey.png')
                  "
                  alt=""
                />
              </template>
            </div>
            <div class="evaluate-info">
              <div
                v-if="textEvaluate.result.accuracy || Number(textEvaluate.result.accuracy) === 0"
                class="evaluate-detail-item"
              >
                <div>{{ Number(textEvaluate.result.accuracy).toFixed(2) }}</div>
                <div class="score-list-name">准确度</div>
              </div>
              <div
                v-if="textEvaluate.result.fluency || Number(textEvaluate.result.fluency) === 0"
                class="evaluate-detail-item"
              >
                <div>{{ Number(textEvaluate.result.fluency).toFixed(2) }}</div>
                <div class="score-list-name">流畅度</div>
              </div>
              <div
                v-if="textEvaluate.result.integrity || Number(textEvaluate.result.integrity) === 0"
                class="evaluate-detail-item"
              >
                <div>{{ Number(textEvaluate.result.integrity).toFixed(2) }}</div>
                <div class="score-list-name">完整度</div>
              </div>
            </div>
          </div>
          <div v-if="textEvaluate.evaluate || textEvaluate.refText" :style="{ zoom: zoom }" class="answer-evaluate">
            <div v-if="textEvaluate.evaluate" class="content" @click="wordInfo" v-html="textEvaluate.evaluate" />
            <template v-else-if="textEvaluate.refText">
              <div class="answer-evaluate-title">参考答案</div>
              <div class="content refText" v-html="textEvaluate.refText" />
            </template>
          </div>
        </div>
        <div class="modal-content-bottom">
          <div class="bottom-box">
            <div class="answer-audio">
              <div class="operation-icon">
                <img
                  v-if="!playing"
                  class="play"
                  :src="require('@/assets/common/black_play.png')"
                  alt=""
                  @click="changePlay(true)"
                />
                <img
                  v-else
                  class="pause"
                  :src="require('@/assets/common/black_pause.png')"
                  alt=""
                  @click="changePlay(false)"
                />
              </div>
              <div class="vertical-line" />
              <AudioProgress
                ref="AudioProgress"
                :is-playing="playing"
                :audio-url="textEvaluate.audioUrl"
                @changePlaying="changePlaying"
                @ontimeupdate="ontimeupdate"
                @onEnded="onEnded"
              />
            </div>
            <div class="font-size-box">
              <div class="font-size-item left" @click="zoomChange('plus')">
                <img src="@/assets/common/font_size_plus.png" />
              </div>
              <div class="gap" />
              <div class="font-size-item right" @click="zoomChange('minus')">
                <img src="@/assets/common/font_size_minus.png" />
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="modal-content-top">
          <div :style="{ zoom: zoom }" class="answer-overall">
            <div
              :class="[
                'answer-score',
                multipleTextEvaluate.scoreRate >= 85
                  ? 'col-1DC060'
                  : multipleTextEvaluate.scoreRate >= 60
                    ? 'col-FFA516'
                    : 'col-FF3C30'
              ]"
            >
              <template v-if="$store.getters.isGradeSchool">
                <img :src="Grade2ImgSrc(Number(multipleTextEvaluate.scoreRate))" alt="" class="score-img" />
              </template>
              <template v-else>
                <span class="score">{{ multipleTextEvaluate.scoreRate }}</span>
                <span class="text">分</span>
              </template>
            </div>
            <div class="answer-star">
              <template v-for="index in 5">
                <img
                  :key="index"
                  class="answer-star-img"
                  :src="
                    index <= fetchStarNum(multipleTextEvaluate.scoreRate)
                      ? require('@/assets/common/star_highlight.png')
                      : require('@/assets/common/star_grey.png')
                  "
                  alt=""
                />
              </template>
            </div>
            <div class="evaluate-info">
              <div class="evaluate-detail-item">
                <div>{{ multipleTextEvaluate.accuracy }}</div>
                <div class="score-list-name">准确度</div>
              </div>
              <div class="evaluate-detail-item">
                <div>{{ multipleTextEvaluate.fluency }}</div>
                <div class="score-list-name">流畅度</div>
              </div>
              <div class="evaluate-detail-item">
                <div>{{ multipleTextEvaluate.integrity }}</div>
                <div class="score-list-name">完整度</div>
              </div>
            </div>
          </div>
          <div v-for="(info, index) in answerInfo" :key="index" :style="{ zoom: zoom }" class="sentence-item">
            <span v-if="info.evaluateText" class="mr-10" @click="wordInfo" v-html="info.evaluateText" />
            <span v-else class="mr-10" v-html="info.originalText" />
            <span v-if="$store.getters.isGradeSchool" class="col-333 mr-10">
              {{ score2Grade(Number(info.ext?.result.scoreRate)) }}
            </span>
            <!-- 角色对话存在未作答的情况，此时userId为空，隐藏分数和名字 -->
            <span v-else-if="info.userId" class="col-333 mr-10">{{ (info.ext?.result.scoreRate || 0) + '分' }}</span>
            <span class="col-333 mr-10">{{ info.userName }}</span>
            <img
              v-if="info.audioUrl"
              :src="
                audioPlaying && clickIndex === index
                  ? require('@/assets/common/audio_play.gif')
                  : require('@/assets/common/audio_play.png')
              "
              @click="playAudio(info, index)"
            />
          </div>
        </div>
        <div class="modal-content-bottom">
          <div class="bottom-box">
            <div class="font-size-box multiple">
              <div class="font-size-item left" @click="zoomChange('plus')">
                <img src="@/assets/common/font_size_plus.png" />
              </div>
              <div class="gap" />
              <div class="font-size-item right" @click="zoomChange('minus')">
                <img src="@/assets/common/font_size_minus.png" />
              </div>
            </div>
          </div>
        </div>
        <audio ref="audio" @ended="endPlay" />
      </template>
      <div v-if="bottomBtnGroupVisible" class="modal-btn-group">
        <a-button class="mr-20" size="large" @click="visible = false">仅关闭</a-button>
        <a-button size="large" @click="handleClickAndNext">关闭并下一步</a-button>
      </div>
    </div>
  </a-modal>
</template>

<script>
import AudioProgress from '@/components/common/AudioProgress.vue'
import { Grade2ImgSrc, score2Grade } from '@/utils'
// 课文听读、教辅、本地专版评测弹框
export default {
  name: 'EvaluateModel',
  components: { AudioProgress },
  data() {
    return {
      visible: false,
      playing: false,
      clickIndex: 0,
      audioPlaying: false,
      zoom: 1,
      title: '',
      textEvaluate: {
        result: {
          overall: 0
        },
        audioUrl: ''
      },
      type: 'single',
      answerInfo: [],
      multipleTextEvaluate: {},
      bottomBtnGroupVisible: false,
      onClose: null,
      onCloseAndNext: null
    }
  },
  computed: {
    modalTitle() {
      return this.$store.getters.activeAnswer && this.$store.getters.activeAnswer.id
        ? (this.$store.getters.activeAnswer.realName || this.$store.getters.activeAnswer.name) + '的作答详情'
        : '作答详情'
    },
    width() {
      if (this.zoom > 1) {
        return 1000 + (this.zoom - 1) * 1000
      } else if (this.zoom < 1) {
        return 1000 - (1 - this.zoom) * 1000
      } else {
        return 1000
      }
    }
  },
  created() {
    this.zoom = localStorage.getItem('ZOOM_CHANGE_NUM') ? Number(localStorage.getItem('ZOOM_CHANGE_NUM')) : 1
  },
  methods: {
    score2Grade,
    Grade2ImgSrc,
    changeVisible(bol) {
      this.visible = bol
    },
    // 获取得分星星数量
    fetchStarNum(overall) {
      overall = Number(overall)
      if (overall >= 80) {
        return 5
      } else if (overall >= 60) {
        return 4
      } else if (overall >= 40) {
        return 3
      } else if (overall >= 20) {
        return 2
      } else {
        return 1
      }
    },
    // 变更播放状态
    changePlay(flag) {
      this.$debounce(300, () => {
        this.playing = flag
      })
    },
    // 播放状态变更
    changePlaying(flag) {
      this.playing = flag
    },
    // 播放时间点
    ontimeupdate(currentTime, duration) {
      this.$emit('ontimeupdate', currentTime, duration)
    },
    // 播放结束
    onEnded() {},
    afterClose() {
      // this.$emit('onmodalclose')
      if (typeof this.onClose === 'function') {
        this.onClose(this)
      }
      if (this.playing) {
        this.playing = false
      }
      this.$destroy()
      this.$el.parentNode.removeChild(this.$el)
    },
    wordInfo(e) {
      const innerText = e.target.innerText
      this.$wordModal(innerText)
    },
    playAudio(info, index) {
      this.clickIndex = index
      if (!this.audioPlaying) {
        this.audioPlaying = true
        this.$refs.audio.src = info.audioUrl
        this.$refs.audio.play()
      } else {
        this.audioPlaying = false
        this.$refs.audio.pause()
      }
    },
    endPlay() {
      this.audioPlaying = false
    },
    zoomChange(type) {
      if (type === 'plus') {
        if (this.zoom >= 1.8) return
        this.zoom = Number(Number(this.zoom + 0.1).toFixed(1))
        localStorage.setItem('ZOOM_CHANGE_NUM', this.zoom)
      }
      if (type === 'minus') {
        if (this.zoom <= 0.5) return
        this.zoom = Number(Number(this.zoom - 0.1).toFixed(1))
        localStorage.setItem('ZOOM_CHANGE_NUM', this.zoom)
      }
    },
    handleClickAndNext() {
      this.visible = false
      if (typeof this.onCloseAndNext === 'function') {
        this.onCloseAndNext(this)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .ant-modal {
  &.answer-modal {
    .ant-modal-content {
      border-radius: 24px;
      .ant-modal-header {
        height: 72px;
        background: url('@/assets/common/model_title.png');
        background-size: 100% 72px;
        border-radius: 24px 24px 0 0;
        padding: 22px 40px;
        .ant-modal-title {
          color: #333333;
          font-size: 20px;
          line-height: 28px;
          font-weight: bold;
        }
      }
      .ant-modal-close {
        top: 14px;
        right: 14px;
        .ant-modal-close-x {
          width: 44px;
          height: 44px;
          line-height: 44px;
        }
      }
      .ant-modal-body {
        border-radius: 0 0 24px 24px;
        padding: 0;
        max-height: calc(100vh - 312px);
        padding-bottom: 28px;
        overflow-y: hidden;
        .modal-content {
          .answer-overall {
            width: 330px;
            height: 202px;
            padding: 20px 0;
            margin: 0 auto;
            display: flex;
            flex-flow: column;
            justify-content: center;
            align-items: center;
            .answer-score {
              display: flex;
              align-items: center;
              .score {
                font-size: 34px;
              }
              .text {
                margin-left: 4px;
                font-size: 18px;
              }
            }
            .answer-star {
              margin-bottom: 20px;
              .answer-star-img {
                width: 16px;
                height: 16px;
                & + .answer-star-img {
                  margin-left: 4px;
                }
              }
            }
          }
          .evaluate-info {
            width: 330px;
            height: 70px;
            display: flex;
            justify-content: center;
            border-top: 1px solid #f1f1f1;
            padding-top: 10px;
            .evaluate-detail-item {
              padding: 7px 0;
              height: 60px;
              text-align: center;
              width: 100px;
              color: #000000;
              font-size: 20px;
              line-height: 28px;
              border-radius: 12px;
              background: linear-gradient(180deg, #ffffff 0%, #f6f6f6 100%);
              & + .evaluate-detail-item {
                margin-left: 14px;
              }
              .score-list-name {
                color: #1976ff;
                font-size: 12px;
                line-height: 18px;
              }
            }
          }
          .answer-evaluate {
            display: flex;
            flex-flow: column;
            justify-content: center;
            align-items: center;
            padding: 0 40px 40px;
            //margin-bottom: 70px;
            .answer-evaluate-title {
              font-size: 20px;
              color: #1976ff;
            }
            .content {
              font-size: 20px;
              line-height: 28px;
              font-weight: bold;
              &.refText {
                color: #1976ff;
              }
            }
            .answer-text {
              font-size: 44px;
              line-height: 62px;
              font-weight: bold;
              color: #1dc060;
            }
            .word-evaluate {
              display: flex;
              justify-content: center;
            }
          }
          .bottom-box {
            margin: 0 auto;
            width: 360px;
            display: flex;
            justify-content: center;
            position: relative;
            .answer-audio {
              width: 320px;
              margin: 0 auto;
              height: 44px;
              background: linear-gradient(180deg, #ffffff 0%, #f1f1f1 100%);
              border-radius: 22px;
              border: 1px solid #e5e5e5;
              display: flex;
              justify-content: center;
              align-items: center;
              //margin-right: 20px;
              padding: 0 20px 0 0;
              user-select: none;

              &:hover {
                border-color: #1976ff;
              }

              .vertical-line {
                width: 1px;
                height: 20px;
                background: #e5e5e5;
                margin: 0 10px;
              }

              .operation-icon {
                display: flex;
                justify-content: center;
                align-items: center;
                margin-left: 5px;

                .pause,
                .play {
                  width: 34px;
                  height: 34px;
                  cursor: pointer;
                }
              }
            }
            .font-size-box {
              position: absolute;
              right: -140px;
              display: flex;
              align-items: center;
              background: rgba(246, 246, 246, 0.6);
              border-radius: 22px;
              &.multiple {
                position: relative;
                left: 0;
                right: 0;
              }
              .gap {
                width: 1px;
                height: 20px;
                background: #e5e5e5;
              }
              .font-size-item {
                width: 60px;
                height: 42px;
                display: flex;
                align-items: center;
                justify-content: center;
                img {
                  width: 20px;
                  height: 20px;
                }
                &.left {
                  &:hover {
                    border-radius: 22px 0 0 22px;
                  }
                }
                &.right {
                  &:hover {
                    border-radius: 0 22px 22px 0;
                  }
                }
                &:hover {
                  cursor: pointer;
                  background: #f6f6f6;
                }
              }
            }
          }
          .sentence-item {
            margin-bottom: 20px;
            padding-left: 40px;
            font-size: 20px;
            div {
              margin-right: 10px;
            }
            img {
              width: 20px;
              height: 20px;
              margin-bottom: 2px;
              cursor: pointer;
            }
            .col-333 {
              color: #333333;
              white-space: nowrap;
            }
            .mr-10 {
              margin-right: 10px;
            }
          }
          .modal-content-top {
            max-height: calc(100vh - 312px - 90px);
            overflow-y: scroll;
          }
          .modal-content-bottom {
            height: 90px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .modal-btn-group {
            position: absolute;
            bottom: -90px;
            left: 50%;
            transform: translateX(-50%);
            .ant-btn {
              min-width: 120px;
              border-radius: 20px;
            }
          }
        }
      }
    }
  }
}
.col-1DC060 {
  color: #1dc060 !important;
}
.col-FFA516 {
  color: #ffa516 !important;
}
.col-FF3C30 {
  color: #ff3c30 !important;
}

.score-img {
  width: 48px;
  height: 48px;
}
</style>
